import React from "react";
import { toast, ToastContainer } from "react-toastify";
import SectionMenuLeft from "../../components/SectionMenuLeft/SectionMenuLeft";
import { useContext } from "react";
import { SidebarContext } from "../../context/SidebarContext";
import "./Template.css";
import { useState } from "react";
import { RxCross1 } from "react-icons/rx";
import { config } from "../../config";
import { useEffect } from "react";
import ReactTable from "../../components/ReactTable/ReactTable.jsx";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { LuArrowLeft } from "react-icons/lu";

function Template() {
  const navigate = useNavigate();
  const { isSidebar } = useContext(SidebarContext);
  const [showModal, setShowModal] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    body: "",
    sentTo: "users",
    sendType: "now",
    scheduledDate: "",
    intervalValue: "",
    intervalUnit: "minutes",
  });
  const role = localStorage.getItem("adminRole");
  const adminCity =
    role === "sub-admin" ? localStorage.getItem("adminCity") : null;
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const confirmDelete = async () => {
    try {
      setDeleting(true);

      const response = await fetch(
        `${config.backEndBaseUrl}notification/template/${deleteId}`,
        { method: "DELETE" },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Delete failed");
      }

      toast.success("Template deleted");

      setShowDeleteModal(false);
      setDeleteId(null);

      fetchTemplates();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setDeleting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "sendType" && {
        scheduledDate: "",
        intervalValue: "",
      }),
    }));
  };
  const MAX_FILE_SIZE = 300 * 1024; // 300 KB

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    //  Allowed types
    const allowedTypes = ["image/jpeg", "image/png"];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG and PNG files are allowed");
      e.target.value = null;
      return;
    }

    //  Size check
    if (file.size > MAX_FILE_SIZE) {
      toast.error("Image must be less than 300 KB");
      e.target.value = null;
      return;
    }

    //  Valid file
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSendNotification = async () => {
    if (!formData.title.trim() || !formData.body.trim()) {
      toast.error("Title and Body are required");
      return;
    }

    try {
      setLoading(true);

      const payload = new FormData();
      payload.append("title", formData.title);
      payload.append("body", formData.body);
      payload.append("sentTo", formData.sentTo);
      payload.append("sendType", formData.sendType);

      if (imageFile) {
        payload.append("image", imageFile);
      }

      // extra payload depending on send type
      if (formData.sendType === "scheduled") {
        payload.append("scheduledDate", formData.scheduledDate);
      }

      if (formData.sendType === "interval") {
        payload.append("intervalValue", formData.intervalValue);
        payload.append("intervalUnit", formData.intervalUnit);
      }

      // choose API endpoint
      let endpoint = "notification/custom/send";

      if (formData.sendType === "scheduled") {
        endpoint = "notification/template/schedule";
      }

      if (formData.sendType === "interval") {
        endpoint = "notification/template/interval";
      }

      if (editId) {
        endpoint = `notification/template/${editId}`;
      }
      const response = await fetch(
        `${config.backEndBaseUrl}${endpoint}${adminCity ? `?adc=${adminCity}` : ""}`,
        {
          method: editId ? "PUT" : "POST",
          body: payload,
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Something went wrong");
      }

      toast.success(
        formData.sendType === "now"
          ? "Notification sent successfully"
          : "Notification scheduled successfully",
      );

      setShowModal(false);

      setFormData({
        title: "",
        body: "",
        sentTo: "users",
        sendType: "now",
        scheduledDate: "",
        intervalValue: "",
        intervalUnit: "minutes",
      });
      setEditId(null);
      setImageFile(null);
      setImagePreview(null);
    } catch (error) {
      toast.error(error.message || "Failed to process notification");
    } finally {
      setLoading(false);
      fetchTemplates();
    }
  };
  const handleEdit = (row) => {
    setFormData({
      title: row.title || "",
      body: row.body || "",
      sentTo: row.sentTo || "users",
      sendType: row.type === "schedule" ? "scheduled" : row.type || "scheduled",
      scheduledDate: row.scheduledDate
        ? new Date(row.scheduledDate._seconds * 1000).toISOString().slice(0, 16)
        : "",
      intervalValue: row.intervalValue || "",
      intervalUnit: row.intervalUnit || "minutes",
    });

    setImagePreview(row.imageUrl || null);
    setImageFile(null);

    setEditId(row.id);
    setShowModal(true);
  };
  const getButtonLabel = () => {
    if (formData.sendType === "scheduled") return "Schedule Notification";
    if (formData.sendType === "interval")
      return "Create Recurring Notification";
    return "Send Notification";
  };
  const isValid =
    formData.title &&
    formData.body &&
    (formData.sendType === "now" ||
      (formData.sendType === "scheduled" && formData.scheduledDate) ||
      (formData.sendType === "interval" && formData.intervalValue));

  const fetchTemplates = async () => {
    try {
      setTemplatesLoading(true);

      const response = await fetch(
        `${config.backEndBaseUrl}notification/templates${adminCity ? `?adc=${adminCity}` : ""}`,
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Failed to fetch templates");
      }

      setTemplates(data.templates || []);
    } catch (error) {
      toast.error(error.message || "Error loading templates");
    } finally {
      setTemplatesLoading(false);
    }
  };

  const TableSkeleton = ({ rows = 6 }) => (
    <div className="table-skeleton">
      {[...Array(rows)].map((_, i) => (
        <div className="skeleton-row" key={i}>
          <div className="skeleton-cell" />
          <div className="skeleton-cell" />
          <div className="skeleton-cell" />
          <div className="skeleton-cell" />
          <div className="skeleton-cell" />
        </div>
      ))}
    </div>
  );
  const columns = useMemo(
    () => [
      {
        header: "Title",
        accessorKey: "title",
      },
      {
        header: "Message",
        accessorKey: "body",
      },
      {
        header: "Audience",
        accessorKey: "sentTo",
        Cell: ({ cell }) => (
          <span
            className={`badge ${cell.row.original.sentTo === "users" ? "bg-dark" : "bg-primary"} text-uppercase`}
          >
            {cell.row.original.sentTo}
          </span>
        ),
      },
      {
        header: "Type",
        accessorKey: "type",
        Cell: ({ cell }) => (
          <span
            className={`badge ${cell.row.original.type === "schedule" ? "bg-warning" : "bg-info"} text-uppercase`}
          >
            {cell.row.original.type}
          </span>
        ),
      },
      {
        header: "Schedule",
        accessorKey: "schedule",
        Cell: ({ cell }) => {
          const row = cell.row.original;

          if (row.type === "schedule") {
            const value = row.scheduledDate;
            if (!value) return "-";

            const date = value._seconds
              ? new Date(value._seconds * 1000)
              : new Date(value);

            return date.toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            });
          }

          if (row.type === "interval") {
            return `${row.intervalValue} ${row.intervalUnit}`;
          }

          return "-";
        },
      },
      {
        header: "Actions",
        accessorKey: "actions",
        Cell: ({ cell }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => handleEdit(cell.row.original)}
            >
              Edit
            </button>

            <button
              className="btn btn-danger btn-sm"
              onClick={() => {
                setDeleteId(cell.row.original.id);
                setShowDeleteModal(true);
              }}
            >
              Delete
            </button>
          </div>
        ),
      },
    ],
    [handleEdit],
  );
  const resetForm = () => {
    setFormData({
      title: "",
      body: "",
      sentTo: "users",
      sendType: "now",
      scheduledDate: "",
      intervalValue: "",
      intervalUnit: "minutes",
    });

    setImageFile(null);
    setImagePreview(null);
    setEditId(null);
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />

            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : 0 }}
              >
                <div className="main-content-inner">
                  <ToastContainer />

                  <div className="wg-box">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div className="flex items-center justify-between mb-4 gap-3">
                        <div className="flex items-center gap-3">
                          <button
                            className="back-btn flex items-center gap-2"
                            onClick={() => navigate("/")}
                          >
                            <LuArrowLeft size={16} />
                            {/* <span>Back</span> */}
                          </button>

                          <h5 className="fare-heading">
                            Notifications Templates
                          </h5>
                        </div>
                      </div>
                      <button
                        className="btn btn-success custom-open-btn"
                        onClick={() => {
                          resetForm();
                          setShowModal(true);
                        }}
                      >
                        Add Template +
                      </button>
                    </div>
                    {templatesLoading ? (
                      <TableSkeleton />
                    ) : (
                      <ReactTable columns={columns} data={templates} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <>
          <div
            className="custom-modal-noti modal fade show d-block"
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content custom-modal-content">
                <div className="modal-header custom-modal-header">
                  <h5 className="modal-title">Send Notification</h5>
                  <button
                    type="button"
                    className="btn-close cross-btn"
                    onClick={() => setShowModal(false)}
                  >
                    <RxCross1 />
                  </button>
                </div>

                <div className="modal-body">
                  <div className="mb-4">
                    <label className="form-label custom-label">Title</label>
                    <input
                      type="text"
                      className="form-control custom-input"
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      placeholder="Enter notification title"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="form-label custom-label">Body</label>
                    <textarea
                      className="form-control custom-input"
                      rows="4"
                      name="body"
                      value={formData.body}
                      onChange={handleChange}
                      placeholder="Enter notification message"
                    ></textarea>
                  </div>
                  <div className="mb-4">
                    <label className="form-label custom-label">
                      Notification Image (Optional)
                    </label>

                    <input
                      type="file"
                      className="form-control custom-input"
                      accept="image/*"
                      onChange={handleImageChange}
                    />

                    <small className="text-muted">Supported: JPG, PNG</small>
                    {(imageFile || imagePreview) && (
                      <img
                        src={
                          imageFile
                            ? URL.createObjectURL(imageFile)
                            : imagePreview
                        }
                        style={{
                          width: "100%",
                          borderRadius: "6px",
                          marginTop: "10px",
                        }}
                      />
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label custom-label">Send To</label>
                    <select
                      className="form-select custom-input"
                      name="sentTo"
                      value={formData.sentTo}
                      onChange={handleChange}
                    >
                      <option value="users">All Users</option>
                      <option value="drivers">All Drivers</option>
                    </select>
                  </div>
                  <div className="mb-4">
                    <label className="form-label custom-label">Send Type</label>

                    <div className="send-type-group mt-2">
                      <label
                        className={`send-type-card ${formData.sendType === "now" ? "active" : ""}`}
                      >
                        <input
                          type="radio"
                          name="sendType"
                          value="now"
                          checked={formData.sendType === "now"}
                          onChange={handleChange}
                        />
                        Send Now
                      </label>

                      <label
                        className={`send-type-card ${formData.sendType === "scheduled" ? "active" : ""}`}
                      >
                        <input
                          type="radio"
                          name="sendType"
                          value="scheduled"
                          checked={formData.sendType === "scheduled"}
                          onChange={handleChange}
                        />
                        Schedule
                      </label>

                      <label
                        className={`send-type-card ${formData.sendType === "interval" ? "active" : ""}`}
                      >
                        <input
                          type="radio"
                          name="sendType"
                          value="interval"
                          checked={formData.sendType === "interval"}
                          onChange={handleChange}
                        />
                        Repeat
                      </label>
                    </div>
                  </div>
                  {formData.sendType === "scheduled" && (
                    <div className="mb-4">
                      <label className="form-label custom-label">
                        Scheduled Date
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control custom-input"
                        name="scheduledDate"
                        value={formData.scheduledDate}
                        onChange={handleChange}
                      />
                    </div>
                  )}
                  {formData.sendType === "interval" && (
                    <div className="mb-4">
                      <label className="form-label custom-label">
                        Repeat Interval
                      </label>

                      <div className="input-group">
                        <input
                          type="number"
                          min="1"
                          className="form-control custom-input"
                          name="intervalValue"
                          value={formData.intervalValue}
                          onChange={handleChange}
                          placeholder="Enter value"
                        />

                        <select
                          className="form-select custom-input"
                          name="intervalUnit"
                          value={formData.intervalUnit}
                          onChange={handleChange}
                          style={{ maxWidth: "150px" }}
                        >
                          <option value="minutes">Minutes</option>
                          <option value="hours">Hours</option>
                          <option value="days">Days</option>
                          <option value="weeks">Weeks</option>
                          <option value="months">Months</option>
                        </select>
                      </div>
                    </div>
                  )}
                </div>

                <div className="modal-footer border-0 pt-0">
                  <button
                    className="btn btn-dark"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn custom-send-btn"
                    onClick={handleSendNotification}
                    disabled={!isValid || loading}
                  >
                    {loading ? "Sending..." : getButtonLabel()}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show custom-backdrop"></div>
        </>
      )}
      {showDeleteModal && (
        <>
          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete Template</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                  ></button>
                </div>

                <div className="modal-body text-center">
                  <p>Are you sure you want to delete this template?</p>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-dark"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={confirmDelete}
                    disabled={deleting}
                  >
                    {deleting ? "Deleting..." : "Delete"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
}

export default Template;
